<!-- Cookie 測試頁：/cookie_test -->
<template>
  <div class="layout_wrapper">
    <h5>Cookie test page</h5>
  </div>
</template>

<script>
export default {
  name: 'CookieTest',
  components: {
  },
  setup () {
  }
};
</script>

<style scoped lang="scss">
@import '@/scss/common/common.scss';

h5 {
  @include font-size-bold-18;

  margin: 20px 0px;
  text-align: center;
}
</style>
